<div>
  <label [attr.for]="'ngSelect_' + randomId">{{label}}</label>
  <span *ngIf="required" class="mandatory">*</span>

  <ng-select 
    #ngSelectCombo 
    [items]="options" 
    [bindLabel]="optionLabel" 
    autofocus
    bindValue="id" 
    placeholder="Seleziona" 
    notFoundText="Nessun risultato" 
    [inputAttrs]="{ autocomplete: 'off', autocorrect: 'off', autocapitalize: 'off' }"
    [disabled]="disabled"
    [clearable]="allowClear" 
    [ngModel]="optionSel" 
    (change)="onSelected($event)" 
    (clear)="onDeselected($event)"
    aria-describedby="descrizioneNgSelect" 
    [compareWith]="compareFn">

    <ng-template ng-option-tmp let-item="item">
      <div [appTooltip]="item[optionLabel]" [appTooltipEnabled]="tooltip" class="custom-option">
        {{item[optionLabel]}}
      </div>
    </ng-template>
  </ng-select>
  <small class="sr-only" id="descrizioneNgSelect">Scegli un elemento dall’elenco {{label}}</small>
</div>